

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Cart } from '../dto/cart/cart'

@Injectable({ providedIn: 'root' })
export class HomeService {
  constructor(private http: HttpClient) {
  }

  getTransactionsToday() : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/today').pipe(map(data => data));
  }

  getTotalAmount() : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/total').pipe(map(data => data));
  }

  getPendingCart() : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/cart/amount/pending').pipe(map(data => data));
  }

  getExpiringCart () : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/cart/amount/expired').pipe(map(data => data));
  }
}
